var exports = {
  "l9": "stickyTitleContainer__et53UM",
  "eW": "stickyTitleLink__ymVVre",
  "uZ": "issueNumberText__rckGJl",
};

module.exports = exports;
